import { ActionItem } from '../../../types/button/ActionButton';
import { useSale } from '../../../hooks/sale/useSale';
import { useSalesButtonActions } from '../../../hooks/sale/useSalesButtonConfig';
import { useSaleEmail } from '../../../hooks/email/useSaleEmail';

export const useSalePdfModalActions = (): ActionItem[] => {

  const { handlerConsultDTE, handlerDownloadJson } =
    useSalesButtonActions();

  const { sendSaleEmail } = useSaleEmail();

  const { form } = useSale();

  return [
    {
      key: 'json',
      onClick: () => handlerDownloadJson(form.id),
    },
    {
      key: 'dte',
      onClick: () => handlerConsultDTE(form.id),
    },
    {
      key: 'email',
      onClick: () => sendSaleEmail(form.id),
    },
  ];
};